import * as tslib_1 from "tslib";
import * as React from 'react';
import OWADatePicker from 'owa-datepicker';
import { now, formatUserDate, createDisplayDate } from 'owa-datetime';
import TimePicker from 'owa-timepicker/lib/components/TimePicker';
import { formatMonthDayYear, formatYear, formatYearMonth } from 'owa-datetime';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { getUserConfiguration } from 'owa-session-store';
var styles = require('./AutomaticRepliesDateTimePicker.scss');
var dateTimeFormatter = {
    formatMonthDayYear: formatMonthDayYear,
    formatMonthYear: formatYearMonth,
    formatYear: formatYear,
    formatDay: function (date) { return date.getDate().toString(); },
};
// Default Min and Max dates with the ones we have in Outlook/ExDateTime.
export var minDate = createDisplayDate(1601, 0, 1);
export var maxDate = createDisplayDate(4501, 0, 1);
var AutomaticRepliesDateTimePicker = /** @class */ (function (_super) {
    tslib_1.__extends(AutomaticRepliesDateTimePicker, _super);
    function AutomaticRepliesDateTimePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AutomaticRepliesDateTimePicker.prototype.render = function () {
        var _a = getUserConfiguration().UserOptions, WeekStartDay = _a.WeekStartDay, ShowWeekNumbers = _a.ShowWeekNumbers, FirstWeekOfYear = _a.FirstWeekOfYear, HourIncrement = _a.HourIncrement, TimeFormat = _a.TimeFormat;
        return (React.createElement("div", { className: this.props.pickerStyle },
            React.createElement(Label, { className: this.props.labelStyle, disabled: !this.props.isEnabled }, this.props.labelText),
            React.createElement(OWADatePicker, { className: styles.datePicker, isMonthPickerVisible: true, today: now(), disabled: !this.props.isEnabled, dateTimeFormatter: dateTimeFormatter, formatDate: formatUserDate, showMonthPickerAsOverlay: true, value: this.props.date, firstDayOfWeek: WeekStartDay, firstWeekOfYear: FirstWeekOfYear, onSelectDate: this.props.dateSelected, minDate: minDate, maxDate: maxDate, showWeekNumbers: ShowWeekNumbers, ariaLabel: this.props.dateAriaLabel }),
            React.createElement(TimePicker, { className: styles.timePicker, selectedTime: this.props.date, onChanged: this.props.onTimeChanged, minutesInterval: HourIncrement, ariaLabel: this.props.timeArialabel, readOnly: !this.props.isEnabled, userTimeFormat: TimeFormat })));
    };
    return AutomaticRepliesDateTimePicker;
}(React.Component));
export default AutomaticRepliesDateTimePicker;
//# sourceMappingURL=AutomaticRepliesDateTimePicker.js.map